<template>
  <div style="border-bottom: solid 1px #ebedf0;">
       <van-field
              readonly
              clickable
              name="picker"
              :left-icon="name"
              :value="defaultValue"
              :label="label"
              required
              placeholder="请选择"
              @click="showPicker = true"
              :rules="[{ required: true, message: '请选择' }]"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                show-toolbar
                ref="picker"
                :value-key="valueKey"
                :columns="columns"
                :default-index="index"
                @confirm="getdata"
                @cancel="showPicker = false"
              />
            </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPicker: false,
      value: "",
      index: 0
    };
  },
  //接收来自父组件的数据
  props: {
    label: {
      type: String,
      default: () => ""
    },
    columns: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: () => "name"
    },
    defaultValue: {
      type: String,
      default: () => ""
    },
    name
  },
  //生命周期实例创建完成后被立即调用
  created() {
    this.setDefault();
  },
  //生命周期挂载完成之后被调用
  mounted() {},
  //组件
  components: {},
  //方法
  methods: {
    setDefault() {
      if (this.defaultValue) {
        for (let i = 0; i < this.columns.length; i++) {
          if (this.columns[i][this.valueKey] == this.defaultValue) {
            this.index = i;
            this.value = this.columns[i][this.valueKey];
          }
        }
      }
    },
    getdata(data) {
      this.value = data[this.valueKey];
      this.showPicker = false;
      this.$emit("getdata", data);
    }
  },
  //监视
  watch: {
    defaultValue: function(val) {
      if (val) {
        for (let i = 0; i < this.columns.length; i++) {
          if (this.columns[i][this.valueKey] == val) {
            this.index = i;
            this.value = this.columns[i][this.valueKey];
          }
        }
      } else {
        this.value = ''
      }
    },
    columns: function(val) {
      if (val) {
        if (this.defaultValue) {
          for (let i = 0; i < val.length; i++) {
            if (val[i][this.valueKey] == this.defaultValue) {
              this.index = i;
              this.value = val[i][this.valueKey];
            }
          }
        }
      }
    }
  }
};
</script>
<style scoped>
</style>    